import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.url = new URL(window.location);
        this.initLinks();

    }

    doHomepageAjax() {
        let xhrUrl = new URL(ajaxVars.url);
        xhrUrl.searchParams.set('action', 'homepage_ajax');
        xhrUrl.searchParams.set('category', this.url.searchParams.get('category') || null);
        xhrUrl.searchParams.set('view', this.url.searchParams.get('view') || 'cards');
        let that = this;

        let xhr = new XMLHttpRequest();
        xhr.open("GET", xhrUrl);
        xhr.send();
        xhr.onload = function (response) {
            if (this.readyState === XMLHttpRequest.DONE && this.status === 200) {
                let result = xhr.responseText;
                document.querySelector('.home-content').classList.remove('-loading');
                document.querySelector('.home-content').innerHTML = result;
            }

            that.initLinks();
            that.call('update', that.el, 'app');
            that.call('addElements', that.el, 'Scroll');
            setTimeout(() => {
                that.call('scrollTo', '.home-scrollto', 'Scroll');
                if (this.url.searchParams.get('view') && this.url.searchParams.get('view') === 'list') {
                    document.querySelectorAll('.home-list_item').forEach(item => {
                        gsap.to(item.querySelectorAll('.char'), {
                            y: 0,
                            duration: 0.8,
                            ease: 'power4.out',
                            stagger: { each: 0.02, from: 'random' }
                        });
                    });
                }
            }, 100);
        };
    };

    initLinks() {
        document.querySelectorAll('.home-nav .link').forEach(a => {
            a.addEventListener('click', (e) => {
                e.preventDefault();
                document.querySelector('.home-content').classList.add('-loading');

                if (a.getAttribute('data-category')) {
                    if (a.getAttribute('data-category') === 'all') {
                        this.url.searchParams.delete('category');
                    } else {
                        this.url.searchParams.set('category', a.getAttribute('data-category'));
                    }
                }
                if (a.getAttribute('data-view')) {
                    this.url.searchParams.set('view', a.getAttribute('data-view'));
                }

                history.pushState(null, '', this.url.href);
                this.doHomepageAjax();
            });
        });
    }
}
